import {theme} from '../lpc/theme'
import {css} from '../theme/css'
import {darken, spacing} from '../theme/theme'

export const root = css`
  min-height: ${spacing(5)};
`

export const link = css`
  cursor: pointer;
  color: ${theme.palette.grey[200]};
  &:active > svg {
    color: ${darken(theme.palette.primary.main, 0.1)};
  }
`
